import { useState, useEffect, useRef } from 'react';

/*
 * - useRef: Una referencia directa al elemento <img> para forzar la actualización del src de forma imperativa.
 * - En lugar de guardar la URL completa, solo guardamos el timestamp
 * - Dos useEffect:
 *   -- Uno maneja el intervalo (sin dependencias adicionales)
 *   -- Otro actualiza el src de la imagen cuando cambia el timestamp o la URL
 * - Actualización imperativa: Al modificar directamente imgRef.current.src, se garantiza
 *   que el navegador recargue la imagen, evitando problemas de caché.
 */


function Webcam({ webcamUrl, title }) {
  const [timestamp, setTimestamp] = useState(Date.now());
  const imgRef = useRef(null);

  useEffect(() => {
    // Actualizar el timestamp cada 5 minutos
    const intervalId = setInterval(() => {
      setTimestamp(Date.now());
    }, 5 * 60 * 1000); // 5 minutos en milisegundos

    return () => clearInterval(intervalId);
  }, []);

  // Forzar la recarga de la imagen cuando cambia el timestamp
  useEffect(() => {
    if (imgRef.current) {
      imgRef.current.src = `${webcamUrl}?t=${timestamp}`;
    }
  }, [timestamp, webcamUrl]);

  return (
    <div>
      <img
        ref={imgRef}
        src={`${webcamUrl}?t=${timestamp}`}
        alt={title || "Imagen de la webcam"}
        style={{ maxWidth: '100%', height: 'auto' }}
        className='border border-1 border-secondary'
      />
      <div className='fs-6 text-secondary'>{title || "Imagen de la webcam"}</div>
    </div>
  );
}

export default Webcam;